import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { AgreementPlanForm } from "@modules/agreementPlans/components";

import { useAgreementPlanEditForm } from "./controller";

export const AgreementPlanEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = useAgreementPlanEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <AgreementPlanForm />
      </FormProvider>
    </Edit>
  );
});
